import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
// eslint-disable-next-line camelcase
import { JSON_parse } from 'uint8array-json-parser';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import { CELL_SETS_HIERARCHY_LOADED, CELL_SETS_LOADING, CELL_SETS_ERROR } from 'redux/actionTypes/cellSets';
import endUserMessages from 'utils/endUserMessages';
import downloadFromS3 from 'utils/work/downloadFromS3';
import getCellSets from 'redux/selectors/cellSets/getCellSets';
import loadCellIds from 'redux/actions/cellSets/loadCellIds';

/**
 * Two-stage cell-sets load:
 *   1. fetch the tiny hierarchy (names/colors/type/tree) -> CELL_SETS_HIERARCHY_LOADED
 *   2. fetch + decode the cellId blobs -> CELL_SETS_IDS_LOADED
 *
 * @param {string} experimentId
 * @param {{ cellClassesToLoad?: string[]|null, forceReload?: boolean }} [options]
 *   `cellClassesToLoad` scopes stage 2 to those classes (incremental reload after a
 *   mutation); null loads every materialized class. `forceReload` re-runs the load
 *   even when cell sets are already loaded (post-mutation / QC reloads).
 */
var loadCellSets = function loadCellSets(experimentId) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$cellClassesToLoa = _ref.cellClassesToLoad,
    cellClassesToLoad = _ref$cellClassesToLoa === void 0 ? null : _ref$cellClassesToLoa,
    _ref$forceReload = _ref.forceReload,
    forceReload = _ref$forceReload === void 0 ? false : _ref$forceReload;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getCellSets, loading, error, updatingClustering, initialLoadPending, reloadRequested, firstOrRetryLoad, signedUrl, hierarchyData, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _getCellSets = getCellSets()(getState().cellSets), loading = _getCellSets.loading, error = _getCellSets.error, updatingClustering = _getCellSets.updatingClustering, initialLoadPending = _getCellSets.initialLoadPending;
            reloadRequested = forceReload || cellClassesToLoad !== null;
            firstOrRetryLoad = (initialLoadPending || error) && !(loading || updatingClustering);
            if (!(!reloadRequested && !firstOrRetryLoad)) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            dispatch({
              type: CELL_SETS_LOADING
            });
            _context.prev = 6;
            _context.next = 9;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/cellSets"));
          case 9:
            signedUrl = _context.sent;
            _context.next = 12;
            return downloadFromS3('CellSets', signedUrl, JSON_parse);
          case 12:
            hierarchyData = _context.sent;
            dispatch({
              type: CELL_SETS_HIERARCHY_LOADED,
              payload: {
                experimentId: experimentId,
                data: hierarchyData.cellSets
              }
            });

            // Stage 2: the cellId blobs (membership). null -> all materialized classes.
            _context.next = 16;
            return dispatch(loadCellIds(experimentId, cellClassesToLoad));
          case 16:
            _context.next = 23;
            break;
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](6);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_FETCHING_CELL_SETS);
            console.error(_context.t0);
            dispatch({
              type: CELL_SETS_ERROR,
              payload: {
                error: errorMessage
              }
            });
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 18]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export default loadCellSets;